module.exports = __webpack_public_path__ + "img/marea-carte-a-madrigalului-2.dc9168c6.jpg";